import { useSelector } from "react-redux";

import { ChildNodeSlottingProvider } from "../library/ChildNodeSlottingProvider";
import { NodeDesigner } from "../NodeDesigner";
import { ContextPanelSelectedNodeProvider, useWarnOnUndeclaredSelectionTarget } from "../selection";
import { rootDesignerNodeOrNullSelector } from "../state";
import type { FindDefinitions } from "../types";
import { useSelectedNodeResetter } from "./useSelectedNodeResetter";

type Props = {
  findDefinitions: FindDefinitions;
};

export const RootNodeDesigner = ({ findDefinitions }: Props) => {
  const rootNode = useSelector(rootDesignerNodeOrNullSelector);
  useSelectedNodeResetter(rootNode?.id);
  useWarnOnUndeclaredSelectionTarget();

  if (!rootNode) {
    // this will happen if you delete the node designs and not the interact module
    return <p>Initialising Module</p>;
  }

  return (
    <ChildNodeSlottingProvider findDefinitions={findDefinitions}>
      <ContextPanelSelectedNodeProvider>
        <NodeDesigner node={rootNode} view="details" />
      </ContextPanelSelectedNodeProvider>
    </ChildNodeSlottingProvider>
  );
};
